import React, { useState, useEffect } from 'react';
import SectionMenuBar, { SectionMenuBarReducer } from '../../../components/section-menu/show-and-hide';
import { questions } from './data/questions';
import { UrlService } from '../../../core/services/UrlService';
import Layout from '../../../components/layout';
import Seo from '../../../components/seo';
import './index.scss';
import Hero from './components/hero';
import $ from 'jquery';
import SelfTestSection from '../../../components/self-test/SelfTestSection';
import AdpkdSelfTestResult from './components/self-test-result';
import ReferenceListSection from '../../../components/reference-list/ReferenceListSection';
import { references } from './data/references';

const AdpkdSelfTest: React.FC = () => {
    const [state, dispatch] = React.useReducer(SectionMenuBarReducer, {
        anchorId: 'intro',
    });

    const [isInit, setIsInit] = React.useState(true);

    React.useEffect(() => {
        if (isInit) {
            setIsInit(false);
        } else {
            $("html, body").animate({ scrollTop: $('.self-test__content-sections').position()?.top - 150 || 0 }, 600);
        }
    }, [state]);

    return (
        <Layout>
            <Seo title="您有多囊腎病嗎？ 1分鐘評估多囊腎病風險" description="您有多囊腎病嗎？ 1分鐘評估多囊腎病風險" ogImage={UrlService.getLocalImageUrl('self-test/adpkd/seo-banner.png')}></Seo>

            <div className="self-test self-test_adpkd">
                <Hero
                    reducer={[state, dispatch]}
                />
                <section className="self-test__content-sections">
                    <div className="container self-test__content-container">
                        <div className="self-test__content-text-container">

                            <h2>解構慢性腎病－常染色體顯性多囊性腎臟病（ADPKD）</h2>
                            <p>
                                腎臟為身體主要器官之一，負責排泄身體內經新陳代謝產生的廢物。當其功能長期受到影響，體內的廢物會累積，影響健康<sup>3</sup>。
                                當腎臟的結構／功能不正常的情況持續超過三個月，我們會稱此為慢性腎病／慢性腎衰竭<sup>4</sup>。
                            </p>
                            <p>
                                當中，多囊性腎臟病（簡稱多囊腎病）是慢性腎衰竭成因之一<sup>3</sup>。
                                多囊腎病是指病人的腎臟會不斷長出囊腫，少至數十顆，嚴重可多達過百顆<sup>5</sup>。
                                囊腫會不斷擴大，影響腎功能，引致泌尿道感染、血尿、腎結石等問題<sup>1,2</sup>。
                            </p>
                            <p>
                                而常染色體顯性多囊性腎臟病（ADPKD）則是最常見的多囊腎病，約有90％多囊腎病病例屬於ADPKD。
                                它亦是最常見的遺傳性腎病，只要父母任何一方患病，便有50％機會遺傳給子女<sup>6</sup>。
                            </p>
                            <p>
                                ADPKD病情可分為慢性腎病的1至5期<sup>5</sup>，患者越早發病，以後生活品質就會越差。
                                囊腫會慢慢取代正常組織，為患者帶來背痛、尿道感染等問題<sup>2</sup>。
                                嚴重患者有機會出現腎衰竭，若沒有透析治療或腎臟移植，則會死亡<sup>7</sup>。
                                除此之外，囊腫更有機會出現在腎臟以外的器官，如大腦、心臟，引致動脈瘤、二尖瓣脫垂等可致命的併發症<sup>2,8</sup>。
                            </p>
                            <p>
                                遺憾的是，此病沒有根治方法，只可透過藥物、透析治療等控制病情。
                                對於ADPKD成年患者，則可透過口服抗利尿激素受體拮抗藥物（俗稱「排水劑」）減緩疾病惡化。
                                排水劑有效減慢囊腫擴大的速度，延緩腎臟功能的衰退<sup>1</sup>。
                                但並非所有患者都可使用此藥物，此藥物只適用於病情迅速惡化以及患有第1期至第4期慢性腎病的成年ADPKD患者。
                            </p>
                        </div>
                        <div className="self-test__content-image-container">
                            <div className="self-test__content-image">
                                <img src={UrlService.getLocalImageUrl('self-test/adpkd/content-img-1.png')}></img>
                                <label>
                                    ADPKD有2分1機會遺傳至下一代<sup>6</sup>
                                </label>
                            </div>
                            <div className="self-test__content-image">
                                <img src={UrlService.getLocalImageUrl('self-test/adpkd/content-img-2.png?2')}></img>
                                <label>
                                    血尿、尿道感染、高血壓、腎功能衰退等併發症一般會在患者30至50歲時開始出現<sup>9</sup>
                                </label>
                            </div>
                            <div className="self-test__content-image">
                                <img src={UrlService.getLocalImageUrl('self-test/adpkd/content-img-3.png')}></img>
                                <label>
                                    約6成多囊腎病患者在70歲時出現腎衰竭<sup>2</sup>
                                </label>
                            </div>
                        </div>
                    </div>
                </section>
                <SelfTestSection
                    id='測試'
                    questions={questions}
                    result={AdpkdSelfTestResult}
                />
                <ReferenceListSection references={references} />
                <section>
                    <div className="container">
                        <p className="mini">
                            此自我測驗謹供學術或參考用途，並非提供任何醫療意見或建議任何商品或服務，亦不可取代任何診斷或治療。有關您個人的治療情況，請諮詢您的醫生為您作出準確的診斷，並提供適合的治療。我們建議您攜帶您的測試結果，協助您及您的醫生、護士或藥劑師全面有效地掌握您的疾病情況。
                        </p>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default AdpkdSelfTest;
